import { SuccessScreen } from './SuccessScreen';
import { useTranslation } from 'react-i18next';

interface Props {
  declined?: boolean;
}

export const RequireValidation = ({ declined }: Props) => {
  const { t } = useTranslation();
  return (
    <SuccessScreen
      title={
        declined
          ? t('application.declined.title')
          : t('application.requireValidation.title')
      }
      description={
        declined
          ? t('application.declined.subtitle')
          : t('application.requireValidation.subtitle')
      }
    />
  );
};
